<script setup lang="ts">
import { useRoute } from 'vue-router';

import { useCalculatorSummaryEstimated } from '../composables/useCalculatorSummaryEstimated';

const route = useRoute();

const { rules } = useCalculatorSummaryEstimated(Number(route.params.calculatorId));
</script>

<template>
  <div class="space-y-4">
    <div class="font-bold text-gray-900">Podsumowanie kalkulacji</div>

    <div class="grid grid-cols-4 gap-6">
      <div :key="rule.id" v-for="rule in rules" class="space-y-2 rounded-[10px] bg-gray-100 p-6">
        <header class="font-normal text-gray-500">{{ rule.name }}</header>
        <p v-tooltip.top="rule.expression" class="font-lora text-2xl font-medium text-gray-800">
          {{ rule.eval }}
          {{ rule.unit }}
        </p>
      </div>
    </div>
  </div>
</template>
